import React from "react";
import "./ContactUs.css";

const ContactUs: React.FC = () => {
  return (
    <div className="contact-container">
      <h2 className="contact-heading">聯絡資訊</h2>
      <ul className="contact-list">
        <li>Email: Bhis1689@gmail.com</li>
        <li>Email: cmhung11@163.com</li>
        <li>Line: 0937629118</li>
        <li>Facebook: bhis1689@gmail.com</li>
      </ul>
    </div>
  );
};

export default ContactUs;
